export const formatSectionName = (sectionName: string): string => {
  const sectionNames: Record<string, string> = {
    "offer-header": "Nagłówek oferty",
    "basic-info": "Informacje podstawowe",
    "plan-summary": "Podsumowanie planu",
    "financial-summary": "Podsumowanie finansowe",
    "call-to-action": "Sekcja kontaktu",
    accommodation: "Noclegi",
    meals: "Wyżywienie",
    conference: "Sale konferencyjne",
    "additional-services": "Usługi dodatkowe",
  };

  return sectionNames[sectionName] || sectionName;
};

export const getSectionOrder = (sectionName: string): number => {
  // Kolejność sekcji według występowania na stronie oferty
  const sectionOrder: Record<string, number> = {
    "offer-header": 1,
    "basic-info": 2,
    "plan-summary": 3,
    accommodation: 4,
    meals: 5,
    conference: 6,
    "additional-services": 7,
    "financial-summary": 8,
    "call-to-action": 9,
  };

  return sectionOrder[sectionName] || 999; // nieznane sekcje na końcu
};

export const formatDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds}s`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return remainingSeconds > 0
      ? `${minutes}m ${remainingSeconds}s`
      : `${minutes}m`;
  } else {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }
};
